import { trackComponent } from "../../utils/events/trackComponent";

trackComponent({
  parentSelector: ".js-user-menu-wrapper",
  childrenClickEvent: "menu",
  trackCategory: "mgm",
});
